<script setup>
import { onMounted, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { LoaderIcon } from 'vue-tabler-icons';
import Previewer from '@/components/Previewer.vue';
import { fetchResources } from '@/connectors/ras';
import ResourceTable from '@/components/Table.vue';

const store = useStore();
const route = useRoute();
const material = computed(() => store.getters['materials/currentMaterial']);
const loading = ref(false);
const textures = ref([]);

onMounted(async () => {
  loading.value = true;
  try {
    await store.dispatch('materials/fetchMaterialById', route.params.materialId);

    const {
      data: { objects: textureResources },
    } = await fetchResources(
      { ids: material.value.data.textures.map(({ id }) => id) },
      { resourceType: 'texture', request: store.state.users.user.session.request },
    );

    textures.value = textureResources;
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <section class="h-full w-full">
    <div v-if="!loading && material" class="material-container">
      <h2 class="material__name col-span-3 flex flex-grow text-2xl">{{ material.name }}</h2>
      <div class="col-span-1 w-full">
        <previewer :key="material.id" :material="material" class="w-full" />
      </div>

      <resource-table
        :columns="[
          { name: 'name', title: 'Name' },
          { name: 'shortId', title: 'Short Id' },
          { name: 'version', title: 'Latest Version' },
        ]"
        :rows="textures"
        title="Textures"
        class="material__textures col-span-2"
      ></resource-table>

      <resource-table
        :columns="[
          { name: 'id', title: 'ID' },
          { name: 'version', title: 'Version' },
        ]"
        :rows="[material]"
        title="Versions"
        class="material__versions col-span-2"
      ></resource-table>
    </div>
    <div
      v-if="loading"
      class="flex h-full w-full items-center justify-center bg-black bg-opacity-20 text-4xl text-brand-600"
    >
      <loader-icon class="animate h-12 w-12 animate-spin" style="animation-duration: 7s" />
    </div>
  </section>
</template>

<style lang="postcss" scoped>
.material-container {
  @apply relative grid h-full w-full grid-cols-4 items-start gap-6 p-6;
}
</style>
